import api from '../utils/axiosConfig';

export default api;